/*
 * Copyright (c) 2024-2025 Nodals AI Ltd
 * All rights reserved.
 */

import { Placement } from './index';
import { SiteConfig } from '../config';

import type { CampaignData } from '../../types/index';
import type { PrebidAdUnit } from '../../types/prebid';

class VideoPlacement extends Placement {
  constructor(
    adUnit: PrebidAdUnit,
    adUnitTransformer: (adUnitCode: string) => string,
    campaignData: CampaignData[],
    siteConfig: SiteConfig
  ) {
    super(adUnit, adUnitTransformer, campaignData, siteConfig);
  }

  protected setSupportedSizes(): void {
    throw new Error('Method not implemented.');
  }

  protected determineVisibility(): void {
    throw new Error('Method not implemented.');
  }

  protected setWrappingDomElement(): void {
    throw new Error('Method not implemented.');
  }

  protected addListeners(): void {
    throw new Error('Method not implemented.');
  }

  protected addAdInteractionListener(): void {
    throw new Error('Method not implemented.');
  }

  protected setSlot(): void {
    throw new Error('Method not implemented.');
  }
}

export { VideoPlacement };
